import api from '../../api'
import {promptData, successPromptData, errorPromptData, getTableHeaderStyle} from '../../util/MessageTools'
import {checkPhoneNumber} from "../../util/checkNumberTools";
import {vuexUserData, vuexTimeData} from '../../util/vuexData'
import router from "../../router";

export default {
  name: 'login',
  data() {
    return {
      name: '登录1',
      registerDiv: false,//注册的div
      loginDiv: true,//登录的div
      updateDiv: false,//修改密码的div
      ordinary: {      //普通登录
        userName: null,
        password: null,
        phone: null,
        verificationCode: null,
      },
      register: {   //注册
        phone: null,
        verificationCode: null,
        userName: null,
        password: null,
        endPassword: null,
      },
      forget: {   //忘记密码
        phone: null,
        verificationCode: null,
        password: null,
        endPassword: null,
      },
      loginRegisterDiv: true,//登录注册Div
      forgetPasswordDiv: false,//忘记密码Div
      verifyPhoneDiv: true,//验证注册时的手机号码的div
      userDiv: false,//注册时候的用户名密码
      registerSuccess: false,//注册成功
      active: 0,//注册时的步骤步骤
      loginType: "短信登录",
      userLoginDiv: true,//用户名登录的Div
      phoneLoginDiv: false,//手机号验证登录的div
      forgetVerifyPhoneDiv: true,//忘记密码时验证的手机号
      forgetUserDiv: false,//忘记密码时重新输入密码时的Div
      forgetActive: 0,//忘记密码的步骤
      updatePasswordSuccess: false,//修改密码成功的Div
      registerVerifyBtn: '发送验证码',
      registerDisabled: false,
      ordinaryVerifyBtn: '发送验证码',
      ordinaryDisabled: false,
      forgetVerifyBtn: '发送验证码',
      forgetDisabled: false,
      WXDiv: false,//盛放微信二维码的Div
      loginModalStatus:false,//是否展示登录弹窗
			loginButtonLoading:false,//登录按钮loading状态
			checkButtonLoading:false,//修改密码按钮loading状态

    }
  },

  methods: {
		/**
		 * 重置输入框内容
		 */
		resetContent(obj){
			Object.keys(obj).forEach((item)=>{
				obj[item] = ''
			})
		},
		/**
		 * 清除页面所有定时器
		 */
		clearAllTimer(){
			// 注册
			this.registerVerifyBtn = '发送验证码'
			this.registerDisabled = false
			// 登录
			this.ordinaryVerifyBtn = '发送验证码'
			this.ordinaryDisabled = false
			// 忘记密码
			this.forgetVerifyBtn = '发送验证码'
			this.forgetDisabled = false
			let qc = setInterval(()=>{},10000);
			for(let i = 0;i<=qc;i++){
				clearInterval(i)
			}
		},
    /**
     * 展示登录弹窗
     */
    showModal(){
      this.loginModalStatus = true;
    },
    aaab() {
      QC.Login({
        btnId: "qqLoginBtn"	//插入按钮的节点id
      });
    },

    getError(name) {
      return this.errors[name] && this.errors[name].length
        ? this.errors[name][0]
        : null
    },

    hasError(name) {
      return this.getError(name) != null
    },

    /**
     * 修改密码去登陆(忘记密码)
     */
    forgetToLogin() {
      this.forgetActive = 0
      this.forgetPasswordDiv = false;
      this.loginRegisterDiv = true
      $('.form_item').removeClass('active')
      $('#loginSpan').addClass('active')
    },

    /**
     * 隐藏div
     */
    closeDiv() {
      this.registerDiv = false
      this.loginDiv = false
      this.updateDiv = false
    },

    /**
     * 隐藏div
     */
    closeDiv1() {
      this.verifyPhoneDiv = false
      this.userDiv = false
      this.registerSuccess = false
    },

    /**
     * 登录页
     */
    clickLogin() {
      this.closeDiv()

			this.loginRegisterDiv = true//点击登录页时同时关闭忘记密码页
			this.forgetPasswordDiv = false

      this.loginDiv = true
      $('.form_item').removeClass('active')
      $('#loginSpan').addClass('active')
			//切换到登录页时清空定时器并清空注册时的输入框内容
			this.clearAllTimer();
			this.resetContent(this.register);
			this.resetContent(this.forget);
    },

    /**
     * 注册页
     */
    clickRegister() {
			// return//暂不开放
      this.active = 0
      this.closeDiv1()
      this.closeDiv()
      this.verifyPhoneDiv = true
      this.registerDiv = true
      $('.form_item').removeClass('active')
      $('#registerSpan').addClass('active')
			//切换到注册页时清空定时器并清空登录时的输入框内容
			this.clearAllTimer();
			this.resetContent(this.ordinary);
    },

    /**
     * 短信登录(切换页面)
     */
    noteVerify() {
      if (this.loginType === "短信登录") {
        this.userLoginDiv = false
        this.phoneLoginDiv = true
        this.loginType = "账号登录"
      } else {
        this.loginType = "短信登录"
        this.userLoginDiv = true
        this.phoneLoginDiv = false
      }
			//切换状态时清空内容
			this.resetContent(this.ordinary);
			this.clearAllTimer();
    },

    /**
     * 忘记密码
     */
    forgetPassword() {
      this.forgetPasswordDiv = true
      this.loginRegisterDiv = false

			//切换到登录页时清空定时器并清空注册时的输入框内容
			this.clearAllTimer();
			this.resetContent(this.ordinary);
    },

    /**
     * 注册完成去登陆
     */
    registerToLogin() {
      this.active = 0
      this.loginDiv = true;
      this.registerDiv = false
      $('.form_item').removeClass('active')
      $('#loginSpan').addClass('active')
    },

    /**
     *登录 (用户名登录和手机号码登录)
     */
    loginButton() {
      let vue = this
      vue.loginButtonLoading = true
      if (this.loginType === '短信登录') {//说明是用户名登录
        if (this.ordinary.userName === "" || this.ordinary.userName === null) {
          promptData('用户名不能为空,请重新输入!', this)
          return
        }
        if (this.ordinary.password === "" || this.ordinary.password === null) {
          promptData('密码不能为空,请重新输入!', this)
          return
        }
        api.login.login(this.ordinary.userName, this.ordinary.password).then(function (response) {
          vue.loginButtonLoading = false
          if (response === null) {
            return
          }
          if (response.data.code === '0') {
            vue.loginModalStatus = false
            //去查询所有的时间
						successPromptData('登录成功!',vue)
            api.login.getGameInfo().then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                //把时间存到vuex里
                let result = response.data.result
                vuexTimeData(result)
              }
            })
            vuexUserData(response.data.result)
          }
        }).catch(error =>{
          vue.loginButtonLoading = false
        })
      } else {//短信登录
        let phoneNumber = this.ordinary.phone
        let verificationCode = this.ordinary.verificationCode
        if (phoneNumber === "" || phoneNumber === null) {
          promptData('手机号不能为空,请重新输入!', this)
          return
        }
        if (verificationCode === "" || verificationCode == null) {
          promptData('验证码不能为空,请重新输入!', this)
          return
        }
        api.login.checkMessageCode(phoneNumber, verificationCode, 2, "").then(function (response) {
          vue.loginButtonLoading = false
          if (response === null) {
            return
          }
          if (response.data.code === '0') {
            vue.loginModalStatus = false
            successPromptData('登录成功!',vue)
            api.login.getGameInfo().then(function (response) {
              if (response == null) {
                return null
              }
              if (response.data.code === "0") {
                //把时间存到vuex里
                let result = response.data.result
                vuexTimeData(result)
              }
            })
            vuexUserData(response.data.result)
          }
        }).catch(error =>{
          vue.loginButtonLoading = false
        })
      }

    },
    /**
     * 注册上一步
     */
    preRegister(){
      this.verifyPhoneDiv = true
      this.userDiv = false
    },
		/**
		 * 忘记密码上一步
		 */
		preUpdate(){
			this.forgetVerifyPhoneDiv = true
			this.forgetUserDiv = false
		},
    /**
     * 注册的第二步
     */
    registerButton() {
      let vue = this
      if (this.register.userName === null || this.register.userName === "") {
        promptData("用户名不能为空!", this)
        return
      }
      if (this.register.password === null || this.register.password === "") {
        promptData("密码不能为空!", this)
        return
      }
      let regex = /^[a-zA-Z0-9]{8,28}$/
      let r = (this.register.password).match(regex)
      if (r == null) {
        promptData("密码只能由数字和字母组成,并大于8位!", this);
        return;
      }
      if (this.register.password !== this.register.endPassword) {
        promptData("输入的密码不一样!", this)
        return
      }
      let user = {}
      user.userPhone = this.register.phone
      user.userName = this.register.userName
      user.password = this.register.password
      user.createTime = new Date()

      api.login.register(user).then(function (response) {
				if(response==null){
					return
				}
        if (response.data.code === '0') {
          vue.active = 2
          vue.userDiv = false
          //注册成功之后，直接返回登录界面
          vue.loginDiv = true
          vue.registerDiv = false
          vue.userDiv = false
          vue.verifyPhoneDiv = true
          // 将输入框置空
					vue.clearAllTimer();
					vue.resetContent(vue.register)
        } else {
          errorPromptData(response.data.result, vue)
        }
      })
    },

    /**
     * 发送验证码
     * @param type  1为注册  2为短信登录  3为忘记密码
     */
    getVerificationCode(type) {
      let phoneNumber = ""
      switch (type) {
        case 1:
          phoneNumber = this.register.phone
          break
        case 2:
          phoneNumber = this.ordinary.phone
          break
        case 3:
          phoneNumber = this.forget.phone
          break
      }

      let vue = this
      if (phoneNumber !== "" && phoneNumber != null) {
        if (checkPhoneNumber(phoneNumber, this)) {

          api.login.verificationCode(phoneNumber, type).then(function (response) {
            if (response == null) {
              return null
            }
            if (response.data.code === "0") {
              vue.tackBtn(type);
            }
          })
        } else {
          return
        }
      } else {
        promptData("请输入手机号!", this)
        return
      }
    },

    /**
     * 验证码倒数60秒  1为注册  2为短信登录  3为忘记密码
     * @param type
     */
    tackBtn(type) {
      let vue = this
      let time = 60;
      let timer = setInterval(() => {
        if (time === 0) {
          clearInterval(timer);
          switch (type) {
            case 1:
              vue.registerVerifyBtn = '发送验证码'
              vue.registerDisabled = false
              break;
            case 2:
              vue.ordinaryVerifyBtn = '发送验证码'
              vue.ordinaryDisabled = false
              break;
            case 3:
              vue.forgetVerifyBtn = '发送验证码'
              vue.forgetDisabled = false
              break
          }
        } else {
          switch (type) {
            case 1:
              vue.registerVerifyBtn = time + '秒后重试'
              vue.registerDisabled = true
              break;
            case 2:
              vue.ordinaryVerifyBtn = time + '秒后重试'
              vue.ordinaryDisabled = true
              break;
            case 3:
              vue.forgetVerifyBtn = time + '秒后重试'
              vue.forgetDisabled = true
              break
          }
          time--;
        }
      }, 1000);
    },

    /**
     * 验证码进行比对
     * @param type  1注册  4忘记密码
     */
    checkVerificationCode(type) {
      let vue = this
      let phoneNumber = ""
      let verificationCode = ""
      if (type === 1) {//注册
        phoneNumber = this.register.phone
        verificationCode = this.register.verificationCode
      } else {//忘记密码
        phoneNumber = this.forget.phone
        verificationCode = this.forget.verificationCode
      }
      if (phoneNumber === "" || phoneNumber == null) {
        promptData("手机号不能为空!", this)
        return
      }
      if (verificationCode == null || verificationCode === "") {
        promptData("验证码不能为空!", this)
        return
      }
      //请求数据
      api.login.checkMessageCode(phoneNumber, verificationCode, type).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === '0') {
          if (type === 1) {
            vue.active = 1
            vue.verifyPhoneDiv = false
            vue.userDiv = true
          } else {
            vue.forgetActive = 1
            vue.forgetVerifyPhoneDiv = false
            vue.forgetUserDiv = true
          }
        } else {
          errorPromptData(response.data.result, vue)
        }
      })
      //测试
      // vue.active = 1
      // vue.verifyPhoneDiv = false
      // vue.userDiv = true

			// vue.forgetActive = 1
			// vue.forgetVerifyPhoneDiv = false
			// vue.forgetUserDiv = true
    },

    /**
     * 忘记密码时修改密码1
     */
    updatePassword() {
      let vue = this
      let p1 = this.forget.password
      let p2 = this.forget.endPassword
      if (p1 === null || p1 === "" || p2 === null || p2 === "") {
        promptData("密码不能为空,请重新输入!", this)
        return
      }
      let regex = /^[a-zA-Z0-9]{8,28}$/
      let r = (this.forget.password).match(regex)
      if (r == null) {
        promptData("密码只能由数字和字母组成,并大于8位!", this);
        return;
      }

      if (p1 !== p2) {
        promptData("两次输入的密码不一样,请重新输入!", this)
        return
      }
      let phoneNumber = this.forget.phone
      let verificationCode = this.forget.verificationCode
			this.checkButtonLoading = true;
      api.login.checkMessageCode(phoneNumber, verificationCode, 3, p1).then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === '0') {
          vue.forgetActive = 2
					vue.forgetPasswordDiv = false
					vue.loginRegisterDiv = true
					vue.updatePasswordSuccess = true
					successPromptData('密码修改成功！',vue)
					//回到第一步
					vue.forgetVerifyPhoneDiv = true
					vue.forgetUserDiv = false
					vue.checkButtonLoading = false;
					//修改成功后清空输入框
					vue.clearAllTimer();
					vue.resetContent(vue.forget);
        } else {
          errorPromptData(response.data.result, vue)
        }
      })
    },

    /**
     * 得到qq数据
     */
    getQQCodeOfState() {
			// return;
      api.login.getQQCodeOfState().then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let result = response.data.result
          let qqState = result.state
          //router.app.$options.store.state.qqState = qqState
          // console.log("存储的state"+qqState)
          // //let url = 'https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101942056&response_type=token&scope=all&redirect_uri=http%3A%2F%2Fwww.ricem.cn%2F%23%2Fentry_notice?state=' + qqState
          // //window.open(url)
          // let tempUrl = window.location.href;
          // if (tempUrl != "" && tempUrl.length > 0 && tempUrl.indexOf("http://ricem.cn") == 0) {
          //   tempUrl = "http://ricem.cn";
          // } else {
          //   tempUrl = "http://www.ricem.cn";
          // }
          QC.Login.showPopup({
            appId:"101942056",
            redirectURI:'http://www.ricem.cn/#/qq_transition?state=' + qqState //登录成功后会自动跳往该地址
          });
        }
      })
    },

    /**
     * 得到微信数据
     */
    getWeChatCodeOfState() {
			// return;//暂时禁用
      let vue = this
      api.login.getWeChatCodeOfState().then(function (response) {
        if (response == null) {
          return null
        }
        if (response.data.code === "0") {
          let bb = document.getElementById("WXDiv_container")
          vue.WXDiv = true
          vue.$nextTick(function () {
            // let tempUrl = window.location.href;
            // if (tempUrl != "" && tempUrl.length > 0 && tempUrl.indexOf("http://ricem.cn") == 0) {
            //   tempUrl = "http://ricem.cn";
            // } else {
            //   tempUrl = "http://www.ricem.cn";
            // }
            let result = response.data.result
            let obj = new WxLogin({
              self_redirect: false,
              id: "WXDiv_container",
              appid: result.appId,
              scope: result.scope,
              redirect_uri: "http://www.ricem.cn",
              // redirect_uri: tempUrl,
              state: result.state,
              style: "",
              href: ""
            });
          })


          //vue.$router.push({path:'/binding'})
        }


      })

    },
  },
  created() {
    /*$(document).ready(function () {
      $('.form_item').click(function () {
        $('.form_item').removeClass('active')
        $(this).addClass('active')
      })
    })*/
  }
}



// WEBPACK FOOTER //
// ./src/js/Login/Login.js